import { type BuildDetailsFieldsParams, field, fullName, selectField, typedField, withLayout } from '../fieldHelpers';
import type { DetailField } from '../types';

export function buildOpportunityInfoFields({
  dealCount,
  offer,
  opportunity,
  opportunityId,
}: BuildDetailsFieldsParams): Array<DetailField> {
  const opportunityInfo = opportunity?.opportunity_info;
  const salesAndForecast = opportunity?.sales_and_forecast;
  const contractAndCommercial = opportunity?.contract_and_commercial;
  const productAndSoloTraveller = opportunity?.product_and_solo_traveller;

  return (
    [
      field('Opportunity Owner', opportunityInfo?.opp_owner_lookup_name__c),
      field(
        'Account Name',
        salesAndForecast?.account_name_text__c || opportunity?.account_18_digit_id__c || offer?.vendor_account_id,
      ),
      field('Opportunity Name', opportunityInfo?.name),
      field('Second Vendor', salesAndForecast?.second_vendor__c),
      field('18 Character ID', opportunityId, 'Salesforce-owned identifier.'),
      selectField('Opportunity Record Type', undefined, ['Escapes - Pre Deal Review', 'Escapes Approved']),
      typedField('Close Date', salesAndForecast?.closedate, 'date'),
      typedField('Contract Signed Date', contractAndCommercial?.contract_signed_date__c, 'date'),
      field('Cost Price Currency', opportunityInfo?.cost_price_currency__c),
      field(
        'Campaign/Market Manager',
        fullName(
          opportunityInfo?.merchant_account_manager_first_name__c,
          opportunityInfo?.merchant_account_manager_last_name__c,
        ),
      ),
      selectField('Includes Solo Traveler Packages', productAndSoloTraveller?.includes_solo_traveller_packages__c, [
        'Yes',
        'No',
      ]),
      field('Reason For No Solo Packages', productAndSoloTraveller?.reason_for_no_solo_packages__c, undefined, true),
      field('Number of Deal Options', dealCount, 'Derived from Deal Options rows.'),
      typedField('Proposal Sent Date', contractAndCommercial?.proposal_sent_date__c, 'datetime-local'),
      typedField('# of Proposal Sent', contractAndCommercial?.of_proposal_sent__c, 'number'),
      selectField('Stage', opportunityInfo?.stagename, [
        'Qualification',
        'Proposal',
        'Negotiation',
        'Closed Won',
        'Closed Lost',
      ]),
      typedField('Proposal Start', undefined, 'date'),
      selectField('Production Stages', opportunityInfo?.production_stages__c, [
        'Not Started',
        'In Progress',
        'Complete',
        'Live',
      ]),
      typedField('Probability (%)', salesAndForecast?.probability, 'number'),
      selectField('Campaign Type', opportunityInfo?.campaign_type__c, [
        'FLASH - standard',
        'FLASH - flexi nights',
        'FLASH - Bundle Module',
      ]),
      selectField('Product Type', offer?.type, ['Hotel', 'Package', 'Experience']),
    ] satisfies Array<DetailField>
  ).map((detailField) => withLayout(detailField, { columns: 4 }));
}
